import type { AgentOptions } from '@newrelic/browser-agent/loaders/agent';

if (import.meta.env.PROD) {
  const options = {
    // NREUM.init
    init: {
      session_replay: {
        enabled: true,
        block_selector: '',
        mask_text_selector: '*',
        sampling_rate: 5.0,
        error_sampling_rate: 100.0,
        mask_all_inputs: true,
        collect_fonts: true,
        inline_images: false,
        fix_stylesheets: true,
        preload: false,
        mask_input_options: {},
      },
      distributed_tracing: { enabled: true },
      performance: { capture_measures: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
    },

    // NREUM.info
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: 'NRJS-56a27e05107f54f6862',
      applicationID: '1103450551',
      sa: 1,
    },

    // NREUM.loader_config
    loader_config: {
      accountID: '3832967',
      trustKey: '965178',
      agentID: '1103450551',
      licenseKey: 'NRJS-56a27e05107f54f6862',
      applicationID: '1103450551',
    },
  } satisfies AgentOptions;

  (async () => {
    const { BrowserAgent } = await import('@newrelic/browser-agent/loaders/browser-agent');
    new BrowserAgent(options);
  })();
}
